import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { PaginatedClientJobSourceOverviewResponse } from "./types";

import { instance } from "@/lib/axios/instance";

interface UseJobSourceClientsParams {
  tenantId: string;
  page?: number;
  pageSize?: number;
  integrationName: string;
  search?: string;
  moduleStatus?: "active" | "inactive" | null;
}

export function useJobSourceClients({
  tenantId,
  page = 1,
  pageSize = 10,
  integrationName,
  search,
  moduleStatus,
}: UseJobSourceClientsParams): UseQueryResult<
  PaginatedClientJobSourceOverviewResponse,
  AxiosError
> {
  return useQuery({
    queryKey: [
      "integrations",
      integrationName,
      "job-source",
      "clients",
      tenantId,
      page,
      pageSize,
      search,
      moduleStatus,
    ],
    queryFn: () =>
      instance
        .get<PaginatedClientJobSourceOverviewResponse>(
          `/api/v2/Integrations/${encodeURIComponent(integrationName)}/job-source/clients`,
          {
            params: {
              tenantId,
              page,
              pageSize,
              ...(search && { search }),
              ...(moduleStatus && { moduleStatus }),
            },
          }
        )
        .then((res) => res.data),
    enabled: !!tenantId && !!integrationName,
    refetchOnReconnect: false,
    staleTime: 20 * 60 * 1000,
  });
}
